import script from "./imageResizer.vue?vue&type=script&setup=true&lang=js"
export * from "./imageResizer.vue?vue&type=script&setup=true&lang=js"

import "./imageResizer.vue?vue&type=style&index=0&id=a41fee3a&lang=less"

const __exports__ = script;

export default __exports__